const globalConfig = {}
export default globalConfig